module.exports = __webpack_public_path__ + "static/media/fvs_salaMendoza_9.7375ed09.jpg";